import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {ITextProps, Text} from "@pg-design/text-module";

import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {HorizontalArticleList} from "./HorizontalArticleList";

interface IProps {
    heading: string;
    articles: IOfferArticle[];
    className?: string;
    as?: ITextProps["as"];
}

export const RelatedArticlesSection = (props: IProps) => {
    const {heading, articles, className, as = "h3"} = props;

    return (
        <div css={containerStyle} className={className}>
            <WideContent>
                <Text as={as} css={headingStyle} variant="headline_4">
                    {heading}
                </Text>

                <HorizontalArticleList articles={articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = (theme: Theme) => css`
    background-color: ${theme.colors.background[200]};
    width: 100%;
    padding-bottom: 3.6rem;
    padding-top: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        padding-bottom: 5.6rem;
        padding-top: 3.6rem;
    }
`;

const headingStyle = (theme: Theme) => css`
    padding-bottom: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        padding-bottom: 3.6rem;
    }
`;
import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {ITextProps, Text} from "@pg-design/text-module";

import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {HorizontalArticleList} from "./HorizontalArticleList";

interface IProps {
    heading: string;
    articles: IOfferArticle[];
    className?: string;
    as?: ITextProps["as"];
}

export const RelatedArticlesSection = (props: IProps) => {
    const {heading, articles, className, as = "h3"} = props;

    return (
        <div css={containerStyle} className={className}>
            <WideContent>
                <Text as={as} css={headingStyle} variant="headline_4">
                    {heading}
                </Text>

                <HorizontalArticleList articles={articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = (theme: Theme) => css`
    background-color: ${theme.colors.background[200]};
    width: 100%;
    padding-bottom: 3.6rem;
    padding-top: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        padding-bottom: 5.6rem;
        padding-top: 3.6rem;
    }
`;

const headingStyle = (theme: Theme) => css`
    padding-bottom: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        padding-bottom: 3.6rem;
    }
`;
